let currentStage = 1;

const normalizeToEnglish = (term) => {
  const map = {
    // French
  "Teinté": "Tinted",
  "Photochromique": "Photochromic",
  "Clair": "Clear",
  "Polarisé uniquement": "Polarized Only",
  "Entièrement teinté": "Fully Tinted",
  "Dégradé": "Gradient",
  "Polarisé": "Polarized",
  "Progressif": "Progressive",
  "Vision unique": "Single Vision",
  "Ordonnance": "Prescription",
  "Plano": "Plano",
  "Polarisé et miroir": "Polarized and Mirrored",

  // Spanish
  "Teñida": "Tinted",
  "Fotocrómico": "Photochromic",
  "Claro": "Clear",
  "Sólo polarizado": "Polarized Only",
  "Totalmente tintado": "Fully Tinted",
  "Gradiente": "Gradient",
  "Polarizado": "Polarized",
  "Progresiva": "Progressive",
  "Visión única": "Single Vision",
  "Prescripción": "Prescription",
  "Plano": "Plano",
  "Polarizados y espejados": "Polarized and Mirrored",

  // German
  "Getönte": "Tinted",
  "Photochrom": "Photochromic",
  "Klar": "Clear",
  "Nur polarisiert": "Polarized Only",
  "Vollständig getönt": "Fully Tinted",
  "Verlauf": "Gradient",
  "Polarisiert": "Polarized",
  "Progressiv": "Progressive",
  "Einstärken": "Single Vision",
  "Verschreibung": "Prescription",
  "Plano": "Plano",
  "Polarisiert und verspiegelt": "Polarized and Mirrored",

  // Japanese
  "色合い": "Tinted",
  "フォトクロミック": "Photochromic",
  "クリア": "Clear",
  "偏光のみ": "Polarized Only",
  "フルティンテッド": "Fully Tinted",
  "グラデーション": "Gradient",
  "偏光": "Polarized",
  "プログレッシブ": "Progressive",
  "シングル・ビジョン": "Single Vision",
  "処方箋": "Prescription",
  "プレーノ": "Plano",
  "偏光とミラー": "Polarized and Mirrored",

  // Chinese (Simplified)
  "有色": "Tinted",
  "光致变色": "Photochromic",
  "清晰": "Clear",
  "仅偏光": "Polarized Only",
  "全有色": "Fully Tinted",
  "渐变": "Gradient",
  "偏光": "Polarized",
  "渐进": "Progressive",
  "单一愿景": "Single Vision",
  "处方": "Prescription",
  "普莱诺": "Plano",
  "偏光和镜面": "Polarized and Mirrored",

  // Korean
  "틴티드": "Tinted",
  "광 변색": "Photochromic",
  "지우기": "Clear",
  "편광 전용": "Polarized Only",
  "완전 틴티드": "Fully Tinted",
  "그라데이션": "Gradient",
  "편광": "Polarized",
  "프로그레시브": "Progressive",
  "단일 비전": "Single Vision",
  "처방전": "Prescription",
  "Plano": "Plano",
  "편광 및 미러링": "Polarized and Mirrored",

  // Norwegian
  "Tonet": "Tinted",
  "Fotokromatisk": "Photochromic",
  "Klar": "Clear",
  "Kun polariserte": "Polarized Only",
  "Fullt tonet": "Fully Tinted",
  "Gradient": "Gradient",
  "Polarisert": "Polarized",
  "Progressiv": "Progressive",
  "Enkelt syn": "Single Vision",
  "Resept": "Prescription",
  "Plano": "Plano",
  "Polarisert og speilet": "Polarized and Mirrored"
  };
  return map[term] || term;
};

function colorShowHideBasedPhotocromic(fully_photo_clear) {
  if (
    fully_photo_clear == "Tinted" ||
    fully_photo_clear == "Photochromic"
  ) {
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102933"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102933"]+label'
    ).hide();
    jQuery('#dynamic_option_id_100116 input[type=radio][value="102934"]')
      .prop("checked", true)
      .trigger("change");
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102934"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102934"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102935"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102935"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102936"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102936"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102937"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102937"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102938"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102938"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102939"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102939"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102940"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102940"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102941"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102941"]+label'
    ).show();
  } else if (fully_photo_clear == "Clear") {
    jQuery('#dynamic_option_id_100116 input[type=radio][value="102933"]')
      .prop("checked", true)
      .trigger("change");
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102933"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102933"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102934"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102934"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102935"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102935"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102936"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102936"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102937"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102937"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102938"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102938"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102939"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102939"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102940"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102940"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102941"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102941"]+label'
    ).hide();
  }
};
function backShowHideBasedPhotocromic(fully_photo_clear) {
  if (
    fully_photo_clear == "Tinted" ||
    fully_photo_clear == "Photochromic"
  ) {
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102933"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102933"]+label'
    ).hide();
    // jQuery('#dynamic_option_id_100116 input[type=radio][value="102934"]').prop('checked', true).trigger('change');
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102934"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102934"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102935"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102935"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102936"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102936"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102937"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102937"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102938"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102938"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102939"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102939"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102940"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102940"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102941"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102941"]+label'
    ).show();
  } else if (fully_photo_clear == "Clear") {
    // jQuery('#dynamic_option_id_100116 input[type=radio][value="102933"]').prop('checked', true).trigger('change');
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102933"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102933"]+label'
    ).show();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102934"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102934"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102935"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102935"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102936"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102936"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102937"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102937"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102938"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102938"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102939"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102939"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102940"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102940"]+label'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102941"]'
    ).hide();
    jQuery(
      '#dynamic_option_id_100116 input[type=radio][value="102941"]+label'
    ).hide();
  }
};

function goToStep2AfterFirstChoice() {
  currentStage = 1;
  updateSteps(currentStage);
  $(".next-btn").show();
  $(".back-btn").hide();
};

function handlePlanoPrescriptionChange(special_effect_data, fully_phpocromic_txt, polarizedType, polarizedText , polarizedMirrorText) {
  special_effect_data = normalizeToEnglish(special_effect_data);
  fully_phpocromic_txt = normalizeToEnglish(fully_phpocromic_txt);
  polarizedType = normalizeToEnglish(polarizedType);
  polarizedText = normalizeToEnglish(polarizedText);
  polarizedMirrorText = normalizeToEnglish(polarizedMirrorText);
  
  let animation_false = false;
  
  if (fully_phpocromic_txt === 'Tinted' &&(special_effect_data === 'Fully Tinted' || special_effect_data === 'Gradient')) {
    currentStage = 3;
  } else if (fully_phpocromic_txt === 'Tinted' && special_effect_data === 'Polarized') {
    currentStage = 4;
  } else {    
    currentStage = 2;
  }
  updateSteps(currentStage, animation_false);
}


function updateSteps(currentStage, animate = true) {
  var typeval =  normalizeToEnglish($('#custom_pOptions input[name="options_10000"]:checked').val());
  var onChangeColor = $('input[name="options_100116"]:checked');
  var onChangeColorTitle = onChangeColor.data("txt");
  var getLensVision =  normalizeToEnglish($("#dynamic_option_id_10080 input[name='options_10080']:checked").attr("data-txt"));
  let loading_progressive_value =  normalizeToEnglish($("input[name='options_10080']:checked").attr("data-txt"));
  var fully_phpocromic_txt =  normalizeToEnglish($('input[name="options_10090"]:checked').attr("data-txt"));
  var special_effect_data =  normalizeToEnglish($('input[name="options_10030"]:checked').attr("data-txt"));
  var polarized_color = normalizeToEnglish($('input[name="options_10061"]:checked').attr("data-txt"));
  var polarized_data = normalizeToEnglish($('#fieldset-section-61 input[name="options_10091"]:checked').attr("data-txt"));
  var mirror_color = normalizeToEnglish($('#dynamic_option_id_10062 input[name="options_10062"]:checked').attr("data-txt"));
  var polarized_mirror_data = normalizeToEnglish($('#fieldset-section-62 input[name="options_10092"]:checked').attr("data-txt"));
  var charging_station_data = $('#fieldset-section-63 input[name="options_10063"]:checked').attr("data-txt");

  if (currentStage === 1) {
    $(".step").hide();
    $('.step[data-step="1"]').show();
    $(".back-btn").hide();
    $(".next-btn").show();
    $("#progress-bar").show();
    $("#progress-bar").css("width", "20%");
    return;
  }
  $("#progress-bar").show();

  if (fully_phpocromic_txt === "Tinted") {
    if (currentStage === 2) {
      $(".step").hide();
      $(".back-btn").show();
      $(".next-btn").show();
      $('.step[data-step="15"]').show();
      $("#progress-bar").css("width", "40%");

      // step updates
      $("#step_update").removeClass("hide");
      $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
      $("#special_effect_data_span").hide();
      $("#typeval_span").hide();
      $("#loading_progressive_value").hide();
      $("#onChangeColorTitle_span").hide();    
      $("#polarized_type").hide();  
      $("#polar_mirror_color").hide();
      $('#charging_station_text').hide();
     
      
      if (animate) {
        $('.step[data-step="15"]').css({ position: "relative", left: "50%" }).show()
          .animate({ left: "0%" }, 500);
      } else {
        $('.step[data-step="15"]').css({ left: "0%" }).show();
      }      
    };
    if(special_effect_data != 'Polarized'){
      // condition for fullytinted and Gradiant 25USD
      if (currentStage === 3){
        $(".step").hide();
        $(".back-btn").show();
        $(".next-btn").show();
        $("#progress-bar").css("width", "60%");        
        const step8 = $('.step[data-step="8"]');

        // steps text updates each steps
        $("#step_update").removeClass("hide");
        $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt).show();
        $("#special_effect_data_span").text(special_effect_data).show();
        $("#typeval_span").hide();
        $("#loading_progressive_value").hide();
        $("#onChangeColorTitle_span").hide();
        $('#charging_station_text').hide();    
        
        if (animate) {
          $('.step[data-step="2"], .step[data-step="3"], .step[data-step="4"]').css({ position: "relative", left: "50%" }).show()
            .animate({ left: "0%" }, 500);
        } else {
          $('.step[data-step="2"], .step[data-step="3"], .step[data-step="4"]').css({ left: "0%" }).show();
        }
        
        if (typeval === "Plano") {
          colorShowHideBasedPhotocromic(fully_phpocromic_txt);
          if (fully_phpocromic_txt === "Tinted") {
            step8.show().find(".field").hide();
            $("#dynamic_option_id_10075").hide();
            const radioValue =
              fully_phpocromic_txt === "Tinted" ? "10290" : "10289";
            $('#dynamic_option_id_10075 input[type=radio][value="'+ radioValue +'"]').prop("checked", true).trigger("change");
          }
        } 
        else {   
          if(special_effect_data === 'Gradient'){
            jQuery('#dynamic_option_id_10080 .control .progressive').hide();
          }else{
            jQuery('#dynamic_option_id_10080 .control .progressive').show();
          }
          
          colorShowHideBasedPhotocromic(fully_phpocromic_txt);

          if(special_effect_data === 'Gradient'){                  
            if ( getLensVision === "Single Vision") {
              step8.show().find(".field").hide();
              $("#dynamic_option_id_10075").hide();
              let radioValue = null;
              if (fully_phpocromic_txt === "Tinted") {
                radioValue = "10290";
              }
              if (radioValue) {
                $('#dynamic_option_id_10075 input[type=radio][value="' + radioValue + '"]').prop("checked", true).trigger("change");
              }
            }
          }else{
            if ( getLensVision === "Single Vision" || getLensVision === "Progressive") {
                  step8.show().find(".field").hide();
              $("#dynamic_option_id_10075").hide();
              if(getLensVision === "Single Vision"){
                $("#dynamic_option_id_10081, #dynamic_option_id_10059").hide();
              }else{
                $("#dynamic_option_id_10081").show();
              }
              let radioValue = null;
              if (fully_phpocromic_txt === "Tinted") {
                radioValue = "10290";
              }
              if (radioValue) {
                $('#dynamic_option_id_10075 input[type=radio][value="' + radioValue + '"]').prop("checked", true).trigger("change");
              }
            }
          }
        };
      }
      if (currentStage === 4) {
        if (typeval == "Plano") {          
          $(".step").hide();
          $(".next-btn").show();
          // $(".back-btn").show();
          // $(".next-btn").hide();
          const step8 = $('.step[data-step="8"]');          
          $("#progress-bar").css("width", "80%");
          step8.show().find(".field").show();
          $("#dynamic_option_id_10075").hide();
          $("#dynamic_option_id_100771").hide();
          $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
          $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");
          $('.step[data-step="15"]').hide();
            
           // steps text update 
          $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt).show();
          $("#special_effect_data_span").text(special_effect_data).show();
          $("#typeval_span").text(typeval).show();
          $("#onChangeColorTitle_span").text(onChangeColorTitle).show();
          $("#loading_progressive_value").hide();   
          // $('#charging_station_text').text(charging_station_data).show();
  
            $(".step").each(function () {
              const stepNum = parseInt($(this).data("step"));
              if (stepNum >= 5 && stepNum < 12) {
                $(this).css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
              }
              // if (stepNum >= 12 && stepNum < 15 ) {
              //   $(this).show();
              // }
            });           
          $('.step[data-step="5"], .step[data-step="6"]').hide();
        }
        else{    
            let includeProgressive = false;
            if (special_effect_data === "Fully Tinted") {
              includeProgressive = true;
            } else if (special_effect_data === "Gradient") {
              includeProgressive = false;
            }    

            if (loading_progressive_value === "Single Vision" || (getLensVision === "Progressive" && includeProgressive)) {
                $(".step").hide();
                $(".next-btn").show();
                // $(".back-btn").show();
                // $(".next-btn").hide();          
                const step8 = $('.step[data-step="8"]');
                step8.show().find(".field").show();
                $("#dynamic_option_id_10075").hide();
                
                if(special_effect_data === "Fully Tinted"){
                  $("#dynamic_option_id_1009").hide();
                  $("#dynamic_option_id_1008").show();
                }else{
                  $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
                }
                // $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
                $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");
                $("#progress-bar").css("width", "80%");
                $('.step[data-step="15"]').hide();
    
                // Steps Updates
                $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt).show();
                $("#special_effect_data_span").text(special_effect_data).show();
                $("#typeval_span").text(typeval).show();
                $("#onChangeColorTitle_span").text(onChangeColorTitle).show();
                $("#loading_progressive_value").text(loading_progressive_value).show();
                // $('#charging_station_text').text(charging_station_data).show();          
      
                $(".step").each(function () {
                  const stepNum = parseInt($(this).data("step"));
                  if (stepNum >= 5 && stepNum < 12) {
                    $(this).css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
                  }
                  // if (stepNum >= 12 && stepNum < 15) {
                  //   $(this).show();
                  // }
                });
              } 
        }
      }
      if(currentStage === 5){
        $(".step").hide();
        $(".back-btn").show();
        $(".next-btn").hide();
        $("#progress-bar").css("width", "80%");        
        const step8 = $('.step[data-step="8"]');

        // steps text updates each steps
        $("#step_update").removeClass("hide");
        $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt).show();
        $("#special_effect_data_span").text(special_effect_data).show();
        $("#typeval_span").text(typeval).show();
        if(typeval != 'Plano'){
          $("#loading_progressive_value").text(loading_progressive_value).show();
        }        
        $("#onChangeColorTitle_span").text(onChangeColorTitle).show();

        $('.step[data-step="18"]').show();

         $(".step").each(function () {
              const stepNum = parseInt($(this).data("step"));
              if (stepNum >= 12 && stepNum < 15 ) {
                $(this).show();
                $(this).css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
              }
          }); 
      } 
    }
    else{
          // condition for after ploarized option select
          if (currentStage === 3) {
              $(".step").hide();
              $(".back-btn").show();
              $(".next-btn").show();
              $("#progress-bar").css("width", "60%");            
              const step8 = $('.step[data-step="8"]');
              $("#dynamic_option_id_10075").hide();
              $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
              $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");
              $('#dynamic_option_id_1009 input[type=radio][value="10288"]').prop("checked", true).trigger("change");            

              // Steps text Update
              $("#step_update").removeClass("hide");
              $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt).show();
              $("#special_effect_data_span").text(special_effect_data).show();
              $("#polarized_type").hide();            
              $("#typeval_span").hide();
              $("#onChangeColorTitle_span").hide();
              $("#loading_progressive_value").hide();
              $("#polar_mirror_color").hide();
              $('#charging_station_text').hide();

              
              if(animate){
                $('.step[data-step="16"]').css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
                $('.step[data-step="17"]').css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
                }else{
                  $('.step[data-step="16"]').css({ left: "0%" }).show();
                  $('.step[data-step="17"]').css({ left: "0%" }).show();
                };

              if(polarized_color == 'Grey'){                
                $('input[name=options_10091][value="10491"]').prop("checked", true).trigger("change");                
              }

              let radioValue = null;
              if (fully_phpocromic_txt === "Tinted") {
                radioValue = "10290";
              }
              if (radioValue) {
                $('#dynamic_option_id_10075 input[type=radio][value="' + radioValue + '"]').prop("checked", true).trigger("change");
              }
              
        };
        if(polarized_data == 'Polarized Only'){
            if(currentStage === 4){
              $(".step").hide();
              $(".back-btn").show();
              $(".next-btn").show();
              $("#progress-bar").css("width", "60%");
              const step8 = $('.step[data-step="8"]');
              step8.show().find(".field").hide();
              $("#dynamic_option_id_10075").hide();
              $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
              $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");
              $('#dynamic_option_id_1009 input[type=radio][value="10288"]').prop("checked", true).trigger("change");              

              // steps text Updates
              $("#step_update").removeClass("hide");
              $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
              $("#special_effect_data_span").text(special_effect_data).show();
              $("#polarized_type").text(polarized_data).show();            
              $("#onChangeColorTitle_span").text(polarized_color).show();
              $("#polar_mirror_color").hide();                   
              $("#typeval_span").hide();
              $("#loading_progressive_value").hide();
              $('#charging_station_text').hide();
              
              if (typeval == "Plano"){
                jQuery('#dynamic_option_id_10080').hide();
                $('.step[data-step="4"]').hide(); 
                if(animate){
                  $('.step[data-step="2"]').css({ position: "relative", left: "50%" }).show()
                  .animate({ left: "0%" }, 500);
                }else{
                  $('.step[data-step="2"]').css({ left: "0%" }).show();
                };
              }
              else{                
                $('#dynamic_option_id_10080 .control .progressive').hide();
                $('.step[data-step="4"]').hide(); 
                if(animate){
                  $('.step[data-step="2"], .step[data-step="3"]').css({ position: "relative", left: "50%" }).show()
                  .animate({ left: "0%" }, 500);
                }else{
                  $('.step[data-step="2"], .step[data-step="3"]').css({ left: "0%" }).show();
                };
              }    
          
              let radioValue = null;
              if (fully_phpocromic_txt === "Tinted") {
                radioValue = "10290";
              }
              if (radioValue) {
                $('#dynamic_option_id_10075 input[type=radio][value="' + radioValue + '"]').prop("checked", true).trigger("change");
              }
            };
            if (currentStage === 5) {
              if (typeval == "Plano") {          
                $(".step").hide();
                $(".next-btn").show();
                // $(".back-btn").show();
                // $(".next-btn").hide();              
                const step8 = $('.step[data-step="8"]');              
                $("#progress-bar").css("width", "80%");
                step8.show().find(".field").hide();
                $("#dynamic_option_id_10075").hide();
                $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
                // $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");           
                // $('#dynamic_option_id_1009 input[type=radio][value="10288"]').prop("checked", true).trigger("change");
                $('.step[data-step="15"]').hide();

                // steps updates 
                $("#step_update").removeClass("hide");
                $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
                $("#special_effect_data_span").text(special_effect_data).show();
                $("#polarized_type").text(polarized_data).show();
                $("#onChangeColorTitle_span").text(polarized_color).show();
                $("#polar_mirror_color").hide();       
                $("#typeval_span").text(typeval).show();
                $("#loading_progressive_value").hide();
                // $('#charging_station_text').text(charging_station_data).show();        

                $(".step").each(function () {
                  const stepNum = parseInt($(this).data("step"));
                  if (stepNum >= 5 && stepNum < 12) {
                    $(this).css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
                  }
                  // if (stepNum >= 12 && stepNum < 15 ) {
                  //   $(this).show();
                  // }
                });
                $('.step[data-step="5"], .step[data-step="6"]').hide();
              }
              else{
                colorShowHideBasedPhotocromic(fully_phpocromic_txt);
                if (getLensVision === "Single Vision") {
                  $(".step").hide();
                  $(".next-btn").show();
                  // $(".back-btn").show();
                  // $(".next-btn").hide();
                  const step8 = $('.step[data-step="8"]');
                  step8.show().find(".field").show();
                  $("#dynamic_option_id_10075").hide();
                  $("#dynamic_option_id_1008").show();
                  $("#dynamic_option_id_1009").hide();
                  // $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
                  // $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");           
                  // $('#dynamic_option_id_1009 input[type=radio][value="10288"]').prop("checked", true).trigger("change");
                  $("#progress-bar").css("width", "80%");
                  $('.step[data-step="15"]').hide();
      
                  // steps updates
                    $("#step_update").removeClass("hide");
                    $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
                    $("#special_effect_data_span").text(special_effect_data).show();
                    $("#polarized_type").text(polarized_data).show();
                    $("#onChangeColorTitle_span").text(polarized_color).show();
                    $("#polar_mirror_color").hide();    
                    $("#typeval_span").text(typeval).show();
                    $("#loading_progressive_value").text(loading_progressive_value).show();          
                    // $('#charging_station_text').text(charging_station_data).show();
        
                    $(".step").each(function () {
                      const stepNum = parseInt($(this).data("step"));
                      if (stepNum >= 5 && stepNum < 12) {
                        $(this).css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
                      }
                      // if (stepNum >= 12 && stepNum < 15) {
                      //   $(this).show();
                      // }
                    }); 
                }
                else{
                  $(".step").hide();
                  $(".next-btn").hide();
                  // $(".back-btn").show();
                  // $(".next-btn").hide();           
                  const step8 = $('.step[data-step="8"]');
                  step8.show().find(".field").show();
                  $("#dynamic_option_id_10075").hide();
                  $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
                  // $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");           
                  // $('#dynamic_option_id_1009 input[type=radio][value="10288"]').prop("checked", true).trigger("change");
                  $("#progress-bar").css("width", "80%");
                  $('.step[data-step="15"]').hide();
                  
                  // steps updates
                  $("#step_update").removeClass("hide");
                  $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
                  $("#special_effect_data_span").text(special_effect_data).show();
                  $("#polarized_type").text(polarized_data).show();
                  $("#onChangeColorTitle_span").text(polarized_color).show();
                  $("#mirror_color").hide();       
                  $("#typeval_span").text(typeval).show();
                  $("#loading_progressive_value").text(loading_progressive_value).show(); 
                  $('#charging_station_text').text(charging_station_data).show();         
      
                  $(".step").each(function () {
                    const stepNum = parseInt($(this).data("step"));
                    if (stepNum >= 5 && stepNum <= 12) {
                      $(this).css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
                    }
                    // if (stepNum >= 12 && stepNum < 15) {
                    //   $(this).show();
                    // }
                  });  
                }
              }
            }
            if(currentStage === 6){
              $(".step").hide();
              $(".back-btn").show();
              $(".next-btn").hide();
              $("#progress-bar").css("width", "80%");
              const step8 = $('.step[data-step="8"]');
              step8.show().find(".field").hide();
              $("#dynamic_option_id_10075").hide();
              $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();

              // steps text Updates
              $("#step_update").removeClass("hide");
              $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
              $("#special_effect_data_span").text(special_effect_data).show();
              $("#polarized_type").text(polarized_data).show();
              $("#onChangeColorTitle_span").text(polarized_color).show();
              $("#polar_mirror_color").hide();    
              $("#typeval_span").text(typeval).show();
              if(typeval != 'Plano'){
                $("#loading_progressive_value").text(loading_progressive_value).show();
              }                     
              $('#charging_station_text').text(charging_station_data).hide();

              $('.step[data-step="18"]').show();

              $(".step").each(function () {
                  const stepNum = parseInt($(this).data("step"));
                  if (stepNum >= 12 && stepNum < 15 ) {
                    $(this).show();
                    $(this).css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
                  }
                });
            }
                
        }
        else if(polarized_mirror_data == 'Polarized and Mirrored'){
            if(currentStage === 4){
              $(".step").hide();
              $(".back-btn").show();
              $(".next-btn").show();
              $("#progress-bar").css("width", "60%");
              const step8 = $('.step[data-step="8"]');
              $('.step[data-step="4"]').hide();
              $('#dynamic_option_id_10080 .control .progressive').hide();
              step8.show().find(".field").hide();
              $("#dynamic_option_id_10075").hide();              
              $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
              $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");
              $('#dynamic_option_id_1009 input[type=radio][value="10288"]').prop("checked", true).trigger("change");              

              // steps text Updates
              $("#step_update").removeClass("hide");
              $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
              $("#special_effect_data_span").text(special_effect_data).show();
              $("#polarized_type").text(polarized_mirror_data).show();
              $("#onChangeColorTitle_span").hide();
              $("#polar_mirror_color").text(mirror_color).show();      
              $("#typeval_span").hide();
              $("#loading_progressive_value").hide();           

              if(animate){
                $('.step[data-step="2"], .step[data-step="3"]').css({ position: "relative", left: "50%" }).show()
                  .animate({ left: "0%" }, 500);
              }else{
                $('.step[data-step="2"], .step[data-step="3"]').css({ left: "0%" }).show();
              };    
          
              let radioValue = null;
              if (fully_phpocromic_txt === "Tinted") {
                radioValue = "10290";
              }
              if (radioValue) {
                $('#dynamic_option_id_10075 input[type=radio][value="' + radioValue + '"]').prop("checked", true).trigger("change");
              }
            };
            if (currentStage === 5) {
              if (typeval == "Plano") {            
                  $(".step").hide();
                  $(".next-btn").show();
                  // $(".back-btn").show();
                  // $(".next-btn").hide();
                  const step8 = $('.step[data-step="8"]');                
                  $("#progress-bar").css("width", "80%");
                  step8.show().find(".field").hide();
                  $("#dynamic_option_id_10075").hide();
                  $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
                  // $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");
                  // $('#dynamic_option_id_1009 input[type=radio][value="10288"]').prop("checked", true).trigger("change");     
                  $('.step[data-step="15"]').hide();
    
                  // steps Updates
                  $("#step_update").removeClass("hide");
                  $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
                  $("#special_effect_data_span").text(special_effect_data).show();
                  $("#polarized_type").text(polarized_mirror_data).show();
                  $("#onChangeColorTitle_span").hide();
                  $("#polar_mirror_color").text(mirror_color).show();     
                  $("#typeval_span").text(typeval).show();
                  $("#loading_progressive_value").text(loading_progressive_value).show();
                  // $('#charging_station_text').text(charging_station_data).show();
    
                $(".step").each(function () {
                  const stepNum = parseInt($(this).data("step"));
                  if (stepNum >= 5 && stepNum < 12) {
                    $(this).css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
                  }
                  // if (stepNum >= 12 && stepNum < 15 ) {
                  //   $(this).show();
                  // }
                });    

                $('.step[data-step="5"], .step[data-step="6"]').hide();
              
              }
             else{
              colorShowHideBasedPhotocromic(fully_phpocromic_txt);
                if (getLensVision === "Single Vision") {             
                  $(".step").hide();
                  $(".next-btn").show(); 
                  // $(".back-btn").show();
                  // $(".next-btn").hide();          
                  const step8 = $('.step[data-step="8"]');
                  step8.show().find(".field").show();
                  $("#dynamic_option_id_10075").hide();
                    $("#dynamic_option_id_1008").show();
                    $("#dynamic_option_id_1009").hide();
                  // $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
                  // $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");
                  // $('#dynamic_option_id_1009 input[type=radio][value="10288"]').prop("checked", true).trigger("change");
                  $("#progress-bar").css("width", "80%");
                  $('.step[data-step="15"]').hide();
    
                  // steps Updates
                  $("#step_update").removeClass("hide");
                  $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
                  $("#special_effect_data_span").text(special_effect_data).show();
                  $("#polarized_type").text(polarized_mirror_data).show();
                  $("#onChangeColorTitle_span").hide();
                  $("#polar_mirror_color").text(mirror_color).show();      
                  $("#typeval_span").text(typeval).show();
                  $("#loading_progressive_value").text(loading_progressive_value).show();         
                  // $('#charging_station_text').text(charging_station_data).show();
      
                  $(".step").each(function () {
                    const stepNum = parseInt($(this).data("step"));
                    if (stepNum >= 5 && stepNum < 12) {
                      $(this).css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
                    }
                    // if (stepNum >= 12 && stepNum < 15) {
                    //   $(this).show();
                    // }
                  });  
               } 
              }
            }; 
            if(currentStage === 6){
              $(".step").hide();
              $(".back-btn").show();
              $(".next-btn").hide();
              $("#progress-bar").css("width", "80%");
              const step8 = $('.step[data-step="8"]');
              
              // steps text Updates
              $("#step_update").removeClass("hide");
              $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
              $("#special_effect_data_span").text(special_effect_data).show();
              $("#polarized_type").text(polarized_mirror_data).show();
              $("#onChangeColorTitle_span").hide();
              $("#polar_mirror_color").text(mirror_color).show();      
              $("#typeval_span").text(typeval).show();
              $("#loading_progressive_value").text(loading_progressive_value).show();  
              $('#charging_station_text').hide();

              $('.step[data-step="18"]').show();

              $(".step").each(function () {
                  const stepNum = parseInt($(this).data("step"));
                  // if (stepNum >= 5 && stepNum < 12) {
                  //   $(this).css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
                  // }
                  if (stepNum >= 12 && stepNum < 15 ) {
                    $(this).show();
                    $(this).css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
                  }
                });
            }
            
        }
      } 
  }
  else{
    if (currentStage === 2) {
      $(".step").hide();
      $(".back-btn").show();
      $(".next-btn").show();
      $("#progress-bar").css("width", "60%");
      const step8 = $('.step[data-step="8"]');

        // Steps text Update
      $("#step_update").removeClass("hide");
      $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
      $("#typeval_span").hide();
      $("#onChangeColorTitle_span").hide();
      $("#loading_progressive_value").hide();
      $("#special_effect_data_span").hide();
      $("#polarized_type").hide();
      $("#polar_mirror_color").hide();
      $('#charging_station_text').hide();
        
      jQuery('#dynamic_option_id_10080 .control .progressive').show();
      
      if (animate) {
        $('.step[data-step="2"], .step[data-step="3"], .step[data-step="4"]').css({ position: "relative", left: "50%" }).show()
          .animate({ left: "0%" }, 500);
      } else {
        $('.step[data-step="2"], .step[data-step="3"], .step[data-step="4"]').css({ left: "0%" }).show();
      }

      if (typeval === "Plano") {
        colorShowHideBasedPhotocromic(fully_phpocromic_txt);
        if (fully_phpocromic_txt === "Photochromic") {
          step8.show().find(".field").hide();
          $("#dynamic_option_id_10075").hide();
          const radioValue =
            fully_phpocromic_txt === "Tinted" ? "10290" : "10289";
          $('#dynamic_option_id_10075 input[type=radio][value="'+ radioValue +'"]').prop("checked", true).trigger("change");
        }
      } 
      else{
        colorShowHideBasedPhotocromic(fully_phpocromic_txt);
        if ( getLensVision === "Single Vision" || getLensVision === "Progressive") {
          step8.show().find(".field").hide();
          $("#dynamic_option_id_10075").hide();
          let radioValue = null;
          if (fully_phpocromic_txt === "Photochromic") {
            radioValue = "10289";
          } else if (fully_phpocromic_txt === "Tinted") {
            radioValue = "10290";
          }
          if (radioValue) {
            $('#dynamic_option_id_10075 input[type=radio][value="' + radioValue + '"]').prop("checked", true).trigger("change");
          }
        }
      }
    };
    if (currentStage === 3) {
        $(".step").hide();
        $(".next-btn").show();
        // $(".back-btn").show();
        // $(".next-btn").hide();
        let fully_photo_clear = normalizeToEnglish(jQuery("input[name='options_10090']:checked").attr("data-txt"));
        const step8 = $('.step[data-step="8"]');

        if(typeval === "Plano"){
          $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt).show();
          $("#typeval_span").text(typeval).show();
          $("#onChangeColorTitle_span").text(onChangeColorTitle).show();
          $("#polar_mirror_color").hide();
          // $('#charging_station_text').text(charging_station_data).show();
        }else if(typeval === "Prescription"){
          $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt).show();
          $("#typeval_span").text(typeval).show();
          $("#onChangeColorTitle_span").text(onChangeColorTitle).show();
          $("#loading_progressive_value").text(loading_progressive_value).show();
          $("#polar_mirror_color").hide();
          // $('#charging_station_text').text(charging_station_data).show();
        }

      if (typeval === "Plano" || typeval === "Prescription") {
        $(".step").each(function () {
          const stepNum = parseInt($(this).data("step"));
          if (stepNum >= 5 && stepNum < 12) {
            $(this).css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
          }
          // if (stepNum >= 12 && stepNum <= 15 ) {
          //   $(this).show();
          // }
        });
        if (typeval === "Plano") {
          $('.step[data-step="5"], .step[data-step="6"]').hide();
        }
      }
      if (loading_progressive_value == "Progressive") {
        $("#progress-bar").css("width", "80%");
        step8.show().find(".field").show();
        $("#dynamic_option_id_10075").hide();

        if (
          fully_photo_clear == "Photochromic" ||
          fully_photo_clear == "Tinted"
        ) {
          $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
        } else if (fully_photo_clear == "Clear") {
          $("#dynamic_option_id_1009").hide();
          $("#dynamic_option_id_10081").show();
        }
      } else if (loading_progressive_value == "Single Vision") {
        step8.show().find(".field").show();
        $("#dynamic_option_id_10075").hide();
        if (
          fully_photo_clear == "Photochromic" ||
          fully_photo_clear == "Tinted"
        ) {
          $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
        } else if (fully_photo_clear == "Clear") {
          $("#dynamic_option_id_1008, #dynamic_option_id_1009").show();
        }
        $("#progress-bar").css("width", "80%");
      }

      if (typeval === "Plano") {
          $("#dynamic_option_id_100771, #dynamic_option_id_10081, #dynamic_option_id_10059").hide();
        }

      $('.step[data-step="15"]').hide();
    }
    if(currentStage === 4){
      $(".step").hide();
      $(".back-btn").show();
      $(".next-btn").hide();
      $("#progress-bar").css("width", "80%");
      const step8 = $('.step[data-step="8"]');

        // Steps text Update
      $("#step_update").removeClass("hide");
      $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt).show();
      $("#typeval_span").text(typeval).show();
      $("#onChangeColorTitle_span").text(onChangeColorTitle).show();
      if(typeval != 'Plano'){
        $("#loading_progressive_value").text(loading_progressive_value).show();
      } 
      $("#special_effect_data_span").hide();
      $("#polarized_type").hide();
      $("#polar_mirror_color").hide();
      $('#charging_station_text').hide();

      $('.step[data-step="18"]').show();

      $(".step").each(function () {
          const stepNum = parseInt($(this).data("step"));
         if (stepNum >= 12 && stepNum < 15 ) {
            $(this).show();
          $(this).css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);
           }
        });
    }
    
  }
};

function backSteps(currentStage) {
  const typeval = normalizeToEnglish($('#custom_pOptions input[name="options_10000"]:checked').val());
  const onChangeColor = $('input[name="options_100116"]:checked');
  const onChangeColorTitle = onChangeColor.data("txt");
  var getLensVision =  normalizeToEnglish($("#dynamic_option_id_10080 input[name='options_10080']:checked").attr("data-txt"));
  var fully_phpocromic_txt = normalizeToEnglish($('input[name="options_10090"]:checked').attr("data-txt"));
  var special_effect_data = normalizeToEnglish($('input[name="options_10030"]:checked').attr("data-txt"));
  var polarized_type_data = normalizeToEnglish($('input[name="options_10061"]:checked').attr("data-txt"));
  var polarized_color = normalizeToEnglish($('input[name="options_10061"]:checked').attr("data-txt"));
  var polarized_data = normalizeToEnglish($('#fieldset-section-61 input[name="options_10091"]:checked').attr("data-txt"));
  var mirror_color = normalizeToEnglish($('#dynamic_option_id_10062 input[name="options_10062"]:checked').attr("data-txt"));
  var polarized_mirror_data = normalizeToEnglish($('#fieldset-section-62 input[name="options_10092"]:checked').attr("data-txt"));
  var charging_station_data = normalizeToEnglish($('#fieldset-section-63 input[name="options_10063"]:checked').attr("data-txt"));
  var loading_progressive_value =  normalizeToEnglish($("input[name='options_10080']:checked").attr("data-txt"));

  console.log(currentStage);
  
  if (currentStage === 1) {
    $(".step").hide();
    $('.step[data-step="1"]')
      .css({ position: "relative", left: "-50%" })
      .show()
      .animate({ left: "0%" }, 500);
    $(".back-btn").hide();
    $(".next-btn").show();
    $("#progress-bar").show();
    $("#progress-bar").css("width", "20%");
    $("#step_update").addClass("hide");
    return;
  }
  $("#progress-bar").show();

  if (fully_phpocromic_txt === "Tinted") {
    if (currentStage === 2) {
      $(".step").hide();
      $(".back-btn").show();
      $(".next-btn").show();
      $("#progress-bar").css("width", "40%");
      $("#step_update").removeClass("hide");
      $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
      $("#typeval_span").hide();
      $("#onChangeColorTitle_span").hide();
      $("#loading_progressive_value").hide();
      $("#special_effect_data_span").hide();
      $("#polar_mirror_color").hide();
      $('#charging_station_text').hide();
      $('.step[data-step="15"]').show();
      $('.step[data-step="15"]').css({ position: "relative", left: "-50%" }).show().animate({ left: "0%" }, 500);      
    };
    if(special_effect_data != 'Polarized'){
      if (currentStage === 3) {
        $(".step").hide();
        $(".back-btn").show();
        $(".next-btn").show();
        $("#progress-bar").css("width", "40%");
        var getLensVision = jQuery("#dynamic_option_id_10080 input[name='options_10080']:checked").attr("data-txt");
        const step8 = $('.step[data-step="8"]');
        
        $("#step_update").removeClass("hide");
        $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
        $("#special_effect_data_span").text(special_effect_data).show();
        $("#typeval_span").text('').hide();
        $("#onChangeColorTitle_span").text('').hide();
        $("#loading_progressive_value").text('').hide();
        $("#polar_mirror_color").hide();
        $('#charging_station_text').hide();
        
        $('.step[data-step="2"], .step[data-step="3"], .step[data-step="4"]').css({ position: "relative", left: "-50%" }).show().animate({ left: "0%" }, 500); 
        if (typeval === "Plano") {
          colorShowHideBasedPhotocromic(fully_phpocromic_txt);
          if (fully_phpocromic_txt === "Tinted") {
            step8.show().find(".field").hide();
            $("#dynamic_option_id_10075").hide();
            const radioValue =
              fully_phpocromic_txt === "Tinted" ? "10290" : "10289";
            $('#dynamic_option_id_10075 input[type=radio][value="'+ radioValue +'"]').prop("checked", true).trigger("change");
          }
        } 
        else if (typeval === "Prescription") {  

          if(special_effect_data === 'Gradient'){
              jQuery('#dynamic_option_id_10080 .control .progressive').hide();
            }else{
              jQuery('#dynamic_option_id_10080 .control .progressive').show();
            }

            colorShowHideBasedPhotocromic(fully_phpocromic_txt);

            // Determine if Progressive should be included
            let includeProgressiveOption = false;
            if (special_effect_data === "Fully Tinted") {
              includeProgressiveOption = true;
            } else if (special_effect_data === "Gradient") {
              includeProgressiveOption = false;
            }
          
          if ( getLensVision === "Single Vision" || (getLensVision === "Progressive" && includeProgressiveOption)) {
            step8.show().find(".field").hide();
            $("#dynamic_option_id_10075").hide();
            let radioValue = null;
            if (fully_phpocromic_txt === "Tinted") {
              radioValue = "10290";
            }
            if (radioValue) {
              $('#dynamic_option_id_10075 input[type=radio][value="' + radioValue + '"]').prop("checked", true).trigger("change");
            }
          }
        }
      }
      if (currentStage === 4){
        if (typeval == "Plano"){          
            $(".step").hide();
            $(".next-btn").show();
            const step8 = $('.step[data-step="8"]');          
            $("#progress-bar").css("width", "60%");
            step8.show().find(".field").show();
            $("#dynamic_option_id_10075").hide();
            $("#dynamic_option_id_100771").hide();
            $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
            $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");
            $('.step[data-step="15"]').hide();
            
            // steps text update 
            $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt).show();
            $("#special_effect_data_span").text(special_effect_data).show();
            $("#typeval_span").text(typeval).show();
            $("#onChangeColorTitle_span").text(onChangeColorTitle).show();
            $("#loading_progressive_value").hide();
            // $('#charging_station_text').text(charging_station_data).show();   

            $(".step").each(function () {
              const stepNum = parseInt($(this).data("step"));
              if (stepNum >= 5 && stepNum < 12) {
                $(this).css({ position: "relative", left: "-50%" }).show().animate({ left: "0%" }, 500);
              }
              // if (stepNum >= 13 && stepNum < 15 ) {
              //   $(this).show();
              // }
            });           
            $('.step[data-step="5"], .step[data-step="6"]').hide();
        }
        else{    
          let includeProgressives = false;
          if (special_effect_data === "Fully Tinted") {
            includeProgressives = true;
          } else if (special_effect_data === "Gradient") {
            includeProgressives = false;
          }    

          if (loading_progressive_value === "Single Vision" || (getLensVision === "Progressive" && includeProgressives)) {
              $(".step").hide();
              $(".next-btn").show();          
              const step8 = $('.step[data-step="8"]');
              step8.show().find(".field").show();
              $("#dynamic_option_id_10075").hide();

              if(special_effect_data === "Fully Tinted"){
                  $("#dynamic_option_id_1009").hide();
                  $("#dynamic_option_id_1008").show();
                }else{
                  $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
                }

              // $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
              $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");
              $("#progress-bar").css("width", "60%");
              $('.step[data-step="15"]').hide();
  
              // Steps Updates
              $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt).show();
              $("#special_effect_data_span").text(special_effect_data).show();
              $("#typeval_span").text(typeval).show();
              $("#onChangeColorTitle_span").text(onChangeColorTitle).show();
              $("#loading_progressive_value").text(loading_progressive_value).show();
              // $('#charging_station_text').text(charging_station_data).show();          
    
              $(".step").each(function () {
                const stepNum = parseInt($(this).data("step"));
              if (stepNum >= 5 && stepNum < 12) {
                  $(this).css({ position: "relative", left: "-50%" }).show().animate({ left: "0%" }, 500);
                }
              // if (stepNum >= 13 && stepNum < 15) {
              //     $(this).show();
              // }
            });
          } 
        }
      }
      // if(currentStage === 5){
      //   $(".step").hide();
      //   $(".back-btn").show();
      //   $(".next-btn").show();
      //   $("#progress-bar").css("width", "50%");
      //   const getLensVision = jQuery("#dynamic_option_id_10080 input[name='options_10080']:checked").attr("data-txt");
      //   const step8 = $('.step[data-step="8"]');
        
      //   $("#step_update").removeClass("hide");
      //   $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt).show();
      //   $("#special_effect_data_span").text(special_effect_data).show();
      //   $("#typeval_span").text(typeval).show();
      //   $("#onChangeColorTitle_span").text(onChangeColorTitle).show();
      //   if(typeval != 'Plano'){
      //     $("#loading_progressive_value").text(getLensVision).show();
      //   } 
      //   $("#polar_mirror_color").hide();
      //   $('#charging_station_text').hide();

      //   $('.step[data-step="18"]').show();
      // }
    }else{
      if (currentStage === 3) {
            $(".step").hide();
            $(".back-btn").show();
            $(".next-btn").show();
            $("#progress-bar").css("width", "40%");
            const getLensVision = jQuery("#dynamic_option_id_10080 input[name='options_10080']:checked").attr("data-txt");
            const polarizedType = jQuery("#dynamic_option_id_10061 input[name='options_10061']:checked").attr("data-txt");
            const step8 = $('.step[data-step="8"]');
            $("#step_update").removeClass("hide");
            $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
            $("#special_effect_data_span").text(special_effect_data).show();
            $("#polarized_type").hide();            
            $("#typeval_span").hide();
            $("#onChangeColorTitle_span").hide();
            $("#loading_progressive_value").hide();
            $("#polar_mirror_color").hide();
            $('#charging_station_text').hide();
        
            $('.step[data-step="16"]').css({ position: "relative", left: "-50%" }).show().animate({ left: "0%" }, 500);
            $('.step[data-step="17"]').css({ position: "relative", left: "-50%" }).show().animate({ left: "0%" }, 500);
                          
      }
      if(polarized_data == 'Polarized Only'){
          if(currentStage === 4){
            $(".step").hide();
            $(".back-btn").show();
            $(".next-btn").show();
            $("#progress-bar").css("width", "60%");
            const step8 = $('.step[data-step="8"]');
            
            $("#step_update").removeClass("hide");
            $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
            $("#special_effect_data_span").text(special_effect_data).show();
            $("#polarized_type").text(polarized_data).show();
            $("#onChangeColorTitle_span").hide();        
            $("#typeval_span").hide();
            $("#onChangeColorTitle_span").hide();
            $("#loading_progressive_value").hide();
            $("#polar_mirror_color").hide();  
            
            
            $('.step[data-step="4"]').hide();
            jQuery('#dynamic_option_id_10080 .control .progressive').hide();
            step8.show().find(".field").hide();
            $("#dynamic_option_id_10075").hide();
            $('.step[data-step="2"], .step[data-step="3"]').css({ position: "relative", left: "-50%" }).show()
              .animate({ left: "0%" }, 500);    
            
                let radioValue = null;
                if (fully_phpocromic_txt === "Tinted") {
                  radioValue = "10290";
                }
                if (radioValue) {
                  $('#dynamic_option_id_10075 input[type=radio][value="' + radioValue + '"]').prop("checked", true).trigger("change");
                }
          };
          if (currentStage === 5) {
              if (typeval == "Plano") {          
                $(".step").hide();
                $(".next-btn").show();              
                const step8 = $('.step[data-step="8"]');              
                $("#progress-bar").css("width", "60%");
                step8.show().find(".field").hide();
                $("#dynamic_option_id_10075").hide();
                // $("#dynamic_option_id_1008").show();
                  // $("#dynamic_option_id_1009").hide();
                $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
                // $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");           
                // $('#dynamic_option_id_1009 input[type=radio][value="10288"]').prop("checked", true).trigger("change");
                $('.step[data-step="15"]').hide();

                // steps updates 
                $("#step_update").removeClass("hide");
                $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
                $("#special_effect_data_span").text(special_effect_data).show();
                $("#polarized_type").text(polarized_data).show();
                $("#onChangeColorTitle_span").text(polarized_color).show();
                $("#polar_mirror_color").hide();       
                $("#typeval_span").text(typeval).show();
                $("#loading_progressive_value").hide();
                // $('#charging_station_text').text(charging_station_data).show();        

                $(".step").each(function () {
                  const stepNum = parseInt($(this).data("step"));
                  if (stepNum >= 5 && stepNum < 12) {
                    $(this).css({ position: "relative", left: "-50%" }).show().animate({ left: "0%" }, 500);
                  }
                });
                $('.step[data-step="5"], .step[data-step="6"]').hide();
              }
              else{
                if (loading_progressive_value === "Single Vision") {
                  $(".step").hide();
                  $(".next-btn").show();
                  const step8 = $('.step[data-step="8"]');
                  step8.show().find(".field").show();
                  $("#dynamic_option_id_10075").hide();
                  $("#dynamic_option_id_1008").show();
                  $("#dynamic_option_id_1009").hide();
                  // $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
                  // $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");           
                  // $('#dynamic_option_id_1009 input[type=radio][value="10288"]').prop("checked", true).trigger("change");
                  $("#progress-bar").css("width", "60%");
                  $('.step[data-step="15"]').hide();
      
                  // steps updates
                    $("#step_update").removeClass("hide");
                    $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
                    $("#special_effect_data_span").text(special_effect_data).show();
                    $("#polarized_type").text(polarized_data).show();
                    $("#onChangeColorTitle_span").text(polarized_color).show();
                    $("#polar_mirror_color").hide();    
                    $("#typeval_span").text(typeval).show();
                    $("#loading_progressive_value").text(loading_progressive_value).show();          
                    // $('#charging_station_text').text(charging_station_data).show();
        
                    $(".step").each(function () {
                      const stepNum = parseInt($(this).data("step"));
                      if (stepNum >= 5 && stepNum < 12) {
                        $(this).css({ position: "relative", left: "-50%" }).show().animate({ left: "0%" }, 500);
                      }                      
                    }); 
                }
                else{
                $(".step").hide();
                $(".next-btn").hide();           
                const step8 = $('.step[data-step="8"]');
                step8.show().find(".field").show();
                $("#dynamic_option_id_10075").hide();
                $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
                // $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");           
                // $('#dynamic_option_id_1009 input[type=radio][value="10288"]').prop("checked", true).trigger("change");
                $("#progress-bar").css("width", "60%");
                $('.step[data-step="15"]').hide();
                  
                // steps updates
                  $("#step_update").removeClass("hide");
                  $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
                  $("#special_effect_data_span").text(special_effect_data).show();
                  $("#polarized_type").text(polarized_data).show();
                  $("#onChangeColorTitle_span").text(polarized_color).show();
                  $("#mirror_color").hide();       
                  $("#typeval_span").text(typeval).show();
                  $("#loading_progressive_value").text(loading_progressive_value).show(); 
                  $('#charging_station_text').text(charging_station_data).show();         
      
                  $(".step").each(function () {
                    const stepNum = parseInt($(this).data("step"));
                    if (stepNum >= 5 && stepNum < 12) {
                      $(this).css({ position: "relative", left: "-50%" }).show().animate({ left: "0%" }, 500);
                    }
                    // if (stepNum >= 13 && stepNum < 15) {
                    //   $(this).show();
                    // }
                  });  
                }
              }
            }
          // if(currentStage === 6){
          //   $(".step").hide();
          //   $(".back-btn").show();
          //   $(".next-btn").show();
          //   $("#progress-bar").css("width", "50%");
          //   const step8 = $('.step[data-step="8"]');
          //   $("#step_update").removeClass("hide");
          //   $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
          //   $("#special_effect_data_span").text(special_effect_data).show();
          //   $("#polarized_type").text(polarized_data).show();
          //   $("#onChangeColorTitle_span").text(polarized_color).show();            
          //   $("#typeval_span").text(typeval).show();
          //   $("#loading_progressive_value").hide();
          //   $("#polar_mirror_color").hide();
          //   $('#charging_station_text').hide();
          //   $('.step[data-step="18"]').show();
          // }
      }else if(polarized_mirror_data == 'Polarized and Mirrored'){
        if(currentStage === 4){
          $(".step").hide();
          $(".back-btn").show();
          $(".next-btn").show();
          $("#progress-bar").css("width", "60%");
          const step8 = $('.step[data-step="8"]');
          
          $("#step_update").removeClass("hide");
          $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
          $("#special_effect_data_span").text(special_effect_data).show();
          $("#polarized_type").text(polarized_mirror_data).show();
          $("#polar_mirror_color").text(mirror_color).show();      
          $("#typeval_span").hide();
          $("#onChangeColorTitle_span").hide();
          $("#loading_progressive_value").text(loading_progressive_value).show(); 
          
          $('.step[data-step="4"]').hide();
          jQuery('#dynamic_option_id_10080 .control .progressive').hide();
          step8.show().find(".field").hide();
          $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
          $("#dynamic_option_id_10075").hide();
          $('.step[data-step="2"], .step[data-step="3"]').css({ position: "relative", left: "-50%" }).show()
            .animate({ left: "0%" }, 500);    
          
              let radioValue = null;
              if (fully_phpocromic_txt === "Tinted") {
                radioValue = "10290";
              }
              if (radioValue) {
                $('#dynamic_option_id_10075 input[type=radio][value="' + radioValue + '"]').prop("checked", true).trigger("change");
              }
        }; 
        if (currentStage === 5) {
              if (typeval == "Plano") {            
                  $(".step").hide();
                  $(".next-btn").show();
                  const step8 = $('.step[data-step="8"]');                
                  $("#progress-bar").css("width", "60%");
                  step8.show().find(".field").hide();
                  $("#dynamic_option_id_10075").hide();
                  $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
                  // $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");
                  // $('#dynamic_option_id_1009 input[type=radio][value="10288"]').prop("checked", true).trigger("change");     
                  $('.step[data-step="15"]').hide();
    
                  // steps Updates
                  $("#step_update").removeClass("hide");
                  $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
                  $("#special_effect_data_span").text(special_effect_data).show();
                  $("#polarized_type").text(polarized_mirror_data).show();
                  $("#onChangeColorTitle_span").hide();
                  $("#polar_mirror_color").text(mirror_color).show();     
                  $("#typeval_span").text(typeval).show();
                  $("#loading_progressive_value").text(loading_progressive_value).show();
                  // $('#charging_station_text').text(charging_station_data).show();
    
                $(".step").each(function () {
                  const stepNum = parseInt($(this).data("step"));
                  if (stepNum >= 5 && stepNum < 12) {
                    $(this).css({ position: "relative", left: "-50%" }).show().animate({ left: "0%" }, 500);
                  }
                  // if (stepNum >= 13 && stepNum < 15 ) {
                  //   $(this).show();
                  // }
                });    

                $('.step[data-step="5"], .step[data-step="6"]').hide();
              
              }
             else{
                if (loading_progressive_value === "Single Vision") {             
                  $(".step").hide();
                  $(".next-btn").show();           
                  const step8 = $('.step[data-step="8"]');
                  step8.show().find(".field").show();
                  $("#dynamic_option_id_10075").hide();
                  $("#dynamic_option_id_1008").show();
                  $("#dynamic_option_id_1009").hide();
                  // $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
                  // $('#dynamic_option_id_1008 input[type=radio][value="10286"]').prop("checked", true).trigger("change");
                  // $('#dynamic_option_id_1009 input[type=radio][value="10288"]').prop("checked", true).trigger("change");
                  $("#progress-bar").css("width", "60%");
                  $('.step[data-step="15"]').hide();
    
                // steps Updates
                  $("#step_update").removeClass("hide");
                  $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
                  $("#special_effect_data_span").text(special_effect_data).show();
                  $("#polarized_type").text(polarized_mirror_data).show();
                  $("#onChangeColorTitle_span").hide();
                  $("#polar_mirror_color").text(mirror_color).show();      
                  $("#typeval_span").text(typeval).show();
                  $("#loading_progressive_value").text(loading_progressive_value).show();         
                  // $('#charging_station_text').text(charging_station_data).show();
      
                  $(".step").each(function () {
                    const stepNum = parseInt($(this).data("step"));
                    if (stepNum >= 5 && stepNum < 12) {
                      $(this).css({ position: "relative", left: "-50%" }).show().animate({ left: "0%" }, 500);
                    }
                    // if (stepNum >= 13 && stepNum < 15) {
                    //   $(this).show();
                    // }
                  });  
               } 
              }
            };
        // if(currentStage === 6){
        //   $(".step").hide();
        //   $(".back-btn").show();
        //   $(".next-btn").show();
        //   $("#progress-bar").css("width", "50%");
        //   const step8 = $('.step[data-step="8"]');
        //   $("#step_update").removeClass("hide");
        //   $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
        //   $("#special_effect_data_span").text(special_effect_data).show();
        //   $("#polarized_type").text(polarized_data).show();
        //   $("#onChangeColorTitle_span").hide();            
        //   $("#typeval_span").text(typeval).show();
        //   $("#loading_progressive_value").hide();
        //   $("#polar_mirror_color").text(mirror_color).show(); 
        //   $('#charging_station_text').hide();
        //   $('.step[data-step="18"]').show();
        // }
        
      }
    }
  }else{
      if (currentStage === 2) {
        $(".step").hide();
        $(".back-btn").show();
        $(".next-btn").show();
        $("#progress-bar").css("width", "40%");
        const getLensVision = normalizeToEnglish(jQuery("#dynamic_option_id_10080 input[name='options_10080']:checked").attr("data-txt"));
        const step8 = $('.step[data-step="8"]');
        $("#step_update").removeClass("hide");
        $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
        $("#typeval_span").hide();
        $("#onChangeColorTitle_span").hide();
        $("#loading_progressive_value").hide();
        $("#special_effect_data_span").hide();
        $("#polar_mirror_color").hide();
        $('#charging_station_text').hide();
        jQuery('#dynamic_option_id_10080 .control .progressive').show();

          $('.step[data-step="2"], .step[data-step="3"], .step[data-step="4"]').css({ position: "relative", left: "-50%" }).show()
            .animate({ left: "0%" }, 500);
      

        if (typeval === "Plano") {
          colorShowHideBasedPhotocromic(fully_phpocromic_txt);
          if (fully_phpocromic_txt === "Tinted" || fully_phpocromic_txt === "Photochromic") {
            step8.show().find(".field").hide();
            $("#dynamic_option_id_10075").hide();
            const radioValue =
              fully_phpocromic_txt === "Tinted" ? "10290" : "10289";
            $('#dynamic_option_id_10075 input[type=radio][value="'+ radioValue +'"]').prop("checked", true).trigger("change");
          }
        } 
        else{
          colorShowHideBasedPhotocromic(fully_phpocromic_txt);
          if ( getLensVision === "Single Vision" || getLensVision === "Progressive") {
            step8.show().find(".field").hide();
            $("#dynamic_option_id_10075").hide();
            let radioValue = null;
            if (fully_phpocromic_txt === "Photochromic") {
              radioValue = "10289";
            } else if (fully_phpocromic_txt === "Tinted") {
              radioValue = "10290";
            }
            if (radioValue) {
              $('#dynamic_option_id_10075 input[type=radio][value="' + radioValue + '"]').prop("checked", true).trigger("change");
            }
          }
        }
      }
      if (currentStage === 3) {
        $(".step").hide();
        $(".next-btn").show();
        let fully_photo_clear = normalizeToEnglish(jQuery("input[name='options_10090']:checked").attr("data-txt"));
        const step8 = $('.step[data-step="8"]');

        if(typeval === "Plano"){
          $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt).show();
          $("#typeval_span").text(typeval).show();
          $("#onChangeColorTitle_span").text(onChangeColorTitle).show();
          $("#polar_mirror_color").hide();
          // $('#charging_station_text').text(charging_station_data).show();
        }else if(typeval === "Prescription"){
          $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt).show();
          $("#typeval_span").text(typeval).show();
          $("#onChangeColorTitle_span").text(onChangeColorTitle).show();
          $("#loading_progressive_value").text(loading_progressive_value).show();
          $("#polar_mirror_color").hide();
          // $('#charging_station_text').text(charging_station_data).show();
        }

        if (typeval === "Plano" || typeval === "Prescription") {
          $(".step").each(function () {
            const stepNum = parseInt($(this).data("step"));
            if (stepNum >= 5 && stepNum < 12) {
              $(this).css({ position: "relative", left: "-50%" }).show().animate({ left: "0%" }, 500);
            }
            // if (stepNum >= 13 && stepNum <= 15 ) {
            //   $(this).show();
            // }
          });
          if (typeval === "Plano") {
            $('.step[data-step="5"], .step[data-step="6"]').hide();
          }
        }
        if (loading_progressive_value == "Progressive") {
          $("#progress-bar").css("width", "60%");
          step8.show().find(".field").show();
          $("#dynamic_option_id_10075").hide();

          if (
            fully_photo_clear == "Photochromic" ||
            fully_photo_clear == "Tinted"
          ) {
            $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
          } else if (fully_photo_clear == "Clear") {
            $("#dynamic_option_id_1009").hide();
          }
        } else if (loading_progressive_value == "Single Vision") {
          step8.show().find(".field").show();
          $("#dynamic_option_id_10075").hide();
          if (
            fully_photo_clear == "Photochromic" ||
            fully_photo_clear == "Tinted"
          ) {
            $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
          } else if (fully_photo_clear == "Clear") {
            $("#dynamic_option_id_1008, #dynamic_option_id_1009").show();
          }
          $("#progress-bar").css("width", "60%");
        }

        if (typeval === "Plano") {
            $("#dynamic_option_id_100771").hide();
          }

        $('.step[data-step="15"]').hide();
      }
      if(currentStage === 4){
        $(".step").hide();
        $(".back-btn").show();
        $(".next-btn").show();
        $("#progress-bar").css("width", "40%");
        const getLensVision = normalizeToEnglish(jQuery("#dynamic_option_id_10080 input[name='options_10080']:checked").attr("data-txt"));
        const step8 = $('.step[data-step="8"]');
        $("#step_update").removeClass("hide");
        $("#fully_phpocromic_txt_span").text(fully_phpocromic_txt);
         $("#typeval_span").text(typeval).show();
        $("#onChangeColorTitle_span").text(onChangeColorTitle).show();
        if(typeval != 'Plano'){
          $("#loading_progressive_value").text(getLensVision).show();
        }
        $("#polar_mirror_color").hide();
        $('#charging_station_text').hide();

        $('.step[data-step="18"]').show();
      }
      // if (currentStage === 4){
      //   $(".step").hide();
      //   $(".next-btn").hide();
      //   $("#progress-bar").css("width", "75%");
      //   let loading_progressive_value = jQuery(
      //     "input[name='options_10080']:checked"
      //   ).attr("data-txt");
      //   let fully_photo_clear = normalizeToEnglish(jQuery("input[name='options_10090']:checked").attr("data-txt"));
      //   const step8 = $('.step[data-step="8"]');

      //   // Show steps based on typeval
      //   if (typeval === "Plano" || typeval === "Prescription") {
      //     $(".step").each(function () {
      //       const stepNum = parseInt($(this).data("step"));
      //       if (stepNum >= 5) $(this).show();
      //     });
      //     if (typeval === "Plano") {
      //       $('.step[data-step="5"], .step[data-step="6"]').hide();
      //     }
      //   }

      //   if (loading_progressive_value == "Progressive") {
      //     step8.show().find(".field").show();
      //     $("#dynamic_option_id_10075").hide();
      //     if (
      //       fully_photo_clear == "Photochromic" ||
      //       fully_photo_clear == "Tinted"
      //     ) {
      //       $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
      //     } else if (fully_photo_clear == "Clear") {
      //       $("#dynamic_option_id_1009").hide();
      //     }
      //   } else if (loading_progressive_value == "Single Vision") {
      //     step8.show().find(".field").show();
      //     $("#dynamic_option_id_10075").hide();
      //     if (
      //       fully_photo_clear == "Photochromic" ||
      //       fully_photo_clear == "Tinted"
      //     ) {
      //       $("#dynamic_option_id_1008, #dynamic_option_id_1009").hide();
      //     } else if (fully_photo_clear == "Clear") {
      //       $("#dynamic_option_id_1008, #dynamic_option_id_1009").show();
      //     }
      //   }
      // }
    }
};

jQuery('body').on('click', '.next-btn', function() {
  if (currentStage < 3) {
    var rtslt = jQuery('#custom_pOptions #select_1002 :selected').val();
    var rtslttxt = jQuery.trim(jQuery('#custom_pOptions #options_1003_text').val());
    var metaipd = jQuery('#custom_pOptions #select_100771 :selected').val();
    currentStage++;

    if (window.innerWidth >= 768) {
      $("html, body").animate({ scrollTop: 150 }, "2000");
    } else {
      $("html, body").animate({ scrollTop: 850 }, "fast");
    }

    var fully_phpocromic_txt = normalizeToEnglish($('input[name="options_10090"]:checked').attr("data-txt"));
    var special_effect_data = normalizeToEnglish($('input[name="options_10030"]:checked').attr("data-txt"));
    if(fully_phpocromic_txt == 'Tinted' && special_effect_data == 'Polarized'){
      console.log('ploarized_select');
      $('input[name=options_10061][value="10371"]').prop("checked", true).trigger("change");
    }else if(fully_phpocromic_txt == 'Tinted' && special_effect_data == 'Gradient'){   
      $('.step[data-step="4"]').css({ position: "relative", left: "50%" }).show().animate({ left: "0%" }, 500);   
      jQuery('input[name="options_10080"][data-txt="Single Vision"]').prop('checked', true).trigger("change");      
    }

    updateSteps(currentStage); 
  } else if (currentStage < 4) { 
    var fully_phpocromic_txt =normalizeToEnglish($('input[name="options_10090"]:checked').attr("data-txt"));
    var special_effect_data = normalizeToEnglish($('input[name="options_10030"]:checked').attr("data-txt"));
    var polarized_type_data = normalizeToEnglish($('input[name="options_10091"]:checked').attr("data-txt"));
    var polarized_mirror_data = normalizeToEnglish($('input[name="options_10092"]:checked').attr("data-txt"));
    var typeval = normalizeToEnglish($('#custom_pOptions input[name="options_10000"]:checked').val()); 

    if(fully_phpocromic_txt != 'Tinted'){
      if (!validateStepFields(4)) {
        return; 
      }
    } 
    currentStage++;

    if (window.innerWidth >= 768) {
      $("html, body").animate({ scrollTop: 150 }, "2000");
    } else {
      $("html, body").animate({ scrollTop: 850 }, "fast");
    }

    if(fully_phpocromic_txt == 'Tinted' && special_effect_data == 'Polarized'){
      if(polarized_type_data == 'Polarized Only'){
        if(typeval == 'Plano'){
          jQuery('input[name=options_10000][value="Prescription"]').prop("checked", true).trigger("change");
            $("#fieldset-section-0 .control ul li").removeClass("slideLift slideRight");
           $("#fieldset-section-0 .control ul li[0]").addClass("slideRight");
        }
      }else if(polarized_mirror_data == 'Polarized and Mirrored'){
        if(typeval == 'Plano'){
          jQuery('input[name=options_10000][value="Prescription"]').prop("checked", true).trigger("change");
            $("#fieldset-section-0 .control ul li").removeClass("slideLift slideRight");
           $("#fieldset-section-0 .control ul li[0]").addClass("slideRight");
        }
      }
    }
     updateSteps(currentStage);
     
  } else if (currentStage < 5) {
    var fully_phpocromic_txt =normalizeToEnglish($('input[name="options_10090"]:checked').attr("data-txt"));
    var special_effect_data = normalizeToEnglish($('input[name="options_10030"]:checked').attr("data-txt"));
    var polarized_type_data = normalizeToEnglish($('input[name="options_10091"]:checked').attr("data-txt"));
    var polarized_mirror_data = normalizeToEnglish($('input[name="options_10092"]:checked').attr("data-txt"));
    var typeval = normalizeToEnglish($('#custom_pOptions input[name="options_10000"]:checked').val()); 
    let loading_progressive_value =  normalizeToEnglish($("input[name='options_10080']:checked").attr("data-txt"));
    

    // Existing validation logic
    if (fully_phpocromic_txt === 'Tinted' && special_effect_data != 'Polarized') {
      console.log(loading_progressive_value + '-----' + currentStage);
      if (typeval === 'Prescription' && loading_progressive_value === 'Progressive') {
        if (!validateStepFields(5)) return;
      } else if (typeval === 'Prescription' && loading_progressive_value === 'Single Vision') {
        if (!validateStepFields(5)) return;
      } else if (typeval === 'Plano') {
        if (!validateStepFields(5)) return;
      }
    }      
    currentStage++;
    console.log('Less--5---'+currentStage);
    if (window.innerWidth >= 768) {
      $("html, body").animate({ scrollTop: 150 }, "2000");
    } else {
      $("html, body").animate({ scrollTop: 850 }, "fast");
    }
    updateSteps(currentStage);
  }else if (currentStage < 6) {
    var fully_phpocromic_txt =normalizeToEnglish($('input[name="options_10090"]:checked').attr("data-txt"));
    var special_effect_data = normalizeToEnglish($('input[name="options_10030"]:checked').attr("data-txt"));
    var polarized_type_data = normalizeToEnglish($('input[name="options_10091"]:checked').attr("data-txt"));
    var polarized_mirror_data = normalizeToEnglish($('input[name="options_10092"]:checked').attr("data-txt"));
    var typeval = normalizeToEnglish($('#custom_pOptions input[name="options_10000"]:checked').val());
    let loading_progressive_value =  normalizeToEnglish($("input[name='options_10080']:checked").attr("data-txt"));

    if(fully_phpocromic_txt === 'Tinted' && special_effect_data === 'Polarized'){
      console.log(loading_progressive_value + '--PLOAOO---' + currentStage);
      if (typeval === 'Prescription' && loading_progressive_value === 'Progressive') {
        if (!validateStepFields(5)) return;
      } else if (typeval === 'Prescription' && loading_progressive_value === 'Single Vision') {
        if (!validateStepFields(5)) return;
      } else if (typeval === 'Plano') {
        if (!validateStepFields(5)) return;
      }
    }

    currentStage++;
    console.log('Less----6---'+currentStage);
    if (window.innerWidth >= 768) {
      $("html, body").animate({ scrollTop: 150 }, "2000");
    } else {
      $("html, body").animate({ scrollTop: 850 }, "fast");
    }
    updateSteps(currentStage);
  }
});

jQuery('body').on('click', '.back-btn', function() {
  if (currentStage > 1) {
    currentStage--;
    if (currentStage === 1) {
      currentStage = 1;
      $(".next-btn").off("click");
    }
    if (window.innerWidth >= 768) {
      $("html, body").animate({ scrollTop: 150 }, "2000");
    } else {
      $("html, body").animate({ scrollTop: 850 }, "fast");
    }
    backSteps(currentStage);
  }
});

updateSteps(currentStage);

function validateStepFields(step) {
  let isValid = true;

  if (step === 4 || step === 5) {
    const lensType = $('input[name="options_10000"]:checked').val(); 
    const lensSubtype = normalizeToEnglish($('input[name="options_10080"]:checked').attr("data-txt"));
    const val1001 = $("#select_1001").val()?.trim();
    const val1002 = $("#select_1002").val()?.trim();
    const val1004 = $("#select_1004").val()?.trim();
    const val1005 = $("#select_1005").val()?.trim();
    const val1003Text = $("#options_1003_text").val()?.trim();
    const val1006Text = $("#options_1006_text").val()?.trim();
    const valIPD = $("#select_100771").val()?.trim();
    // const valModel = $('input[name="options_10021"]:checked').val();
    const valModel = $("#model_frame_select").val()?.trim();
    // const antiBlue = $('input[name="options_1008"]:checked').val();
    // const valModel = $('input[name="tier1_model"]:checked').val();
    // const tier2 = $('#tier2_size_select').val();
    const isTermsChecked = $("#options_10051").is(":checked");
    const valAddSPH = $("#select_10081").val()?.trim();
    const isProgressiveTermsChecked = $("#options_10059").is(":checked");

    $(".validation-error").removeClass("validation-error");
    $(".validation-advice").remove();

    const isValidAXS = (val) => {
      const num = parseFloat(val);
      return !isNaN(num) && num >= 1 && num <= 180;
    };

    // // ✅ Always validate Model
    // if (!valModel || !tier2) {
    //   isValid = false;
    //   jQuery("#custom_pOptions #dynamic_option_id_10021").after(`<div class="validation-advice">Please select a Ray-Ban Meta Frame model.</div>`);
    // }

    // ✅ Always validate Model
    // if (!valModel) {
    //   isValid = false;
    //   $('input[name="options_10021"]').first().closest("ul").after(`<div class="validation-advice">Please select a Ray-Ban Meta Frame model.</div>`);
    // }

    // ✅ Always validate Model Frame dropdown
    if (!valModel) {
      isValid = false;
      $("#model_frame_select")
        .addClass("validation-error")
        .after(
          `<div class="validation-advice">Please select a Ray-Ban Meta Frame model.</div>`
        );
    }

    // if (!antiBlue) {
    //   isValid = false;
    //   $("#dynamic_option_id_1008").addClass("validation-error").after(`<div class="validation-advice">Please select.</div>`);
    // }

    // ✅ Always validate Terms checkbox
    if (!isTermsChecked) {
      isValid = false;
      $("#options_10051").addClass("validation-error").closest("li").after(`<div class="validation-advice">Checkbox Require</div>`);
    }

    if (lensType === "Plano") {
      return isValid; // only Model and Terms required
    }

    // ✅ Prescription requires full validation
    if (!valIPD) {
      isValid = false;
      $("#select_100771").addClass("validation-error").after(`<div class="validation-advice">Please select your IPD.</div>`);
    }

    if (lensSubtype === "Progressive") {
      if (!valAddSPH) {
        isValid = false;
        $("#select_10081").addClass("validation-error").after(`<div class="validation-advice">Please select your ADD+ SPH value.</div>`);
      }
      if (!isProgressiveTermsChecked) {
        isValid = false;
        $("#options_10059").addClass("validation-error").closest("li").after(`<div class="validation-advice">Checkbox Require</div>`);
      }
    }

    // ✅ Conditional AXS logic with independent group validation
    const group1Selected = val1001 && val1001 !== "Please select" && val1002 && val1002 !== "Please select";
    const group2Selected = val1004 && val1004 !== "Please select" && val1005 && val1005 !== "Please select";
    const group3Selected = val1001 && val1001 !== "Please select" && val1004 && val1004 !== "Please select" &&
                           (!val1002 || val1002 === "Please select") && (!val1005 || val1005 === "Please select");

    let axsValid = true;

    if (group1Selected) {
      if (!isValidAXS(val1003Text)) {
        axsValid = false;
        isValid = false;
        $("#options_1003_text").addClass("validation-error").after(`<div class="validation-advice">Enter a value between 1 and 180.</div>`);
      }
    }

    if (group2Selected) {
      if (!isValidAXS(val1006Text)) {
        axsValid = false;
        isValid = false;
        $("#options_1006_text").addClass("validation-error").after(`<div class="validation-advice">Enter a value between 1 and 180.</div>`);
      }
    }

    if (!group1Selected && !group2Selected && !group3Selected) {
      axsValid = false;
    }

    if (!axsValid) {
      isValid = false;
      if (!val1001 || val1001 === "Please select") {
        $("#select_1001").addClass("validation-error").after(`<div class="validation-advice">This field is required.</div>`);
      }
      if (!val1004 || val1004 === "Please select") {
        $("#select_1004").addClass("validation-error").after(`<div class="validation-advice">This field is required.</div>`);
      }
    }
  }

  return isValid;
}


//Adding class for show animation effect during toggle yes or no option
$('input[name="options_10000"]').on("click", function () {
  $("#fieldset-section-0 .control ul li").removeClass("slideLift slideRight");
  const $checkedLi = $(
    '#fieldset-section-0 .control ul li input[name="options_10000"]:checked'
  ).closest("li");
  const isPrec = $checkedLi.find('label[for="radio_prec"]').length > 0;

  if (isPrec) {
    $checkedLi.addClass("slideRight");
  } else {
    $checkedLi.addClass("slideLift");
  }
});
